//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// pain-or-priority-event imports
import { IContainer, IProps, IState } from "./PainOrPriorityEvent.d";
import { painOrPriorityEventFragments } from "./PainOrPriorityEvent.gql";
import { styles } from "./PainOrPriorityEvent.styles";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
// import { getCurrentOrg } from '@util/org.util';
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class PainOrPriorityEventCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <div className={this.props.classes.container}>
        Clockwise Inconvenience / Priority Suggestion
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const PainOrPriorityEventStyled = withStyles(styles)(PainOrPriorityEventCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const PainOrPriorityEventRedux = connect(mapStateToProps, {})(PainOrPriorityEventStyled);

//////////////////
// RELAY
//////////////////
export const PainOrPriorityEvent = createFragmentContainer<IContainer>(
  PainOrPriorityEventRedux,
  painOrPriorityEventFragments,
);
